export default __webpack_public_path__ + "static/media/Image-3.e631d672.png";